import { AuthConstants } from 'cc-common';
import { environment } from '../../environments/environment';

export class Constants {
    static localeEnglishUS = 'en-US';
    static ciraConnectCompanyName = 'CiraConnect';
    static passwordSpecialCharactersAllowable = AuthConstants.passwordSpecialCharactersAllowed.join('');

    static smallDeviceMaxWidth = 768;
    static extraSmallDeviceMaxWidth = 575;
    static defaultCiraChatDepartment = 'BEST - Team Members';
    static defaultManagementCompanyName = 'Management Company';

    static splitterFormWidth = '60';
    static splitterPDFViewerWidth = '40';

    static splitterPDFViewerToLeft = true;
    static defaultFormLabelLocation = 'left';

    static minDate = new Date(1900, 0, 1);
    static maxDate = new Date(2100, 0, 1);

    static splitterLeftPanelWidth = '30';
    static splitterRightPanelWidth = '70';

    static splitterEmailViewerWidth = '50';
    static splitterEmailReadingPaneWidth = '50';

    static splitterLeftGridPanelWidth = '50';
    static splitterRightGridPanelWidth = '50';

    static splitterMyTextViewerWidth = '60';
    static splitterMyTextReadingPaneWidth = '40';

    static defaultPopupWindowWidth = 800;
    static defaultPopupWindowHeight = 600;
    static defaultLoadPanelDelay = 1000;
    static defaultSecurityInfoDelay = 1500;

    static communityPathPattern = `:communityId`;
    static propertyPathPattern = `:customerId`;
    static communityQueryPattern = `communityId=:communityId`;
    static propertyQueryPattern = `customerId=:customerId`;

    static defaultCiraMailRefreshRate = environment.defaultCiraMailRefreshRate;
    static defaultAccAcknowledgementText = `Complete the forms and attach any supporting documentation, plans and/or photos of the
                        improvement. Your information will be reviewed in accordance with the guidelines for your
                        community. Work should not commence until the committee has provided feedback.`;

    static portalType = 'MP';
    static defaultScrollbarView = 'always';
    static defaultScrollbarType = 'modern';

    static largeDataSourceSize = 100;
    static mapKeys = {
        google: 'AIzaSyBybPH5N0cpBS-6Rxb-D4xB5BEori6FA-s&libraries=places'
    };

    // BE Logic to calculate maxLength for Notes in Violation
    // reason = "Closed": ";
    // reason is 8 char which has Closed text, one colon & one space
    // Additional 3 for one space and two brackets i.e.,{reason} ({closeReason}
    static violationNotesPrefixLength = 11;
    static violationNotesMaxlength = 150;
}
